import _ from 'lodash'
import React from 'react'

import LeaderboardTable from '../LeaderboardTable'
import useSalesLeaderboardData from './hooks/useLtoLeaderboardData'

interface IProps {
  leaderboardTitle: string
  dataColumnHeader: string
  salesType: string
  leaderboardType: string
  locationId: number | string
  startDate: string
  endDate: string
  dayPart: string
  storeName: string
  isExpanded: boolean
}

function SalesLeaderboard({
  leaderboardTitle,
  dataColumnHeader,
  salesType,
  leaderboardType,
  locationId,
  startDate,
  endDate,
  dayPart,
  storeName,
  isExpanded,
}: IProps) {
  const { leaderboardData } = useSalesLeaderboardData(
    salesType,
    leaderboardType,
    locationId,
    startDate,
    endDate,
    dayPart,
  )

  return (
    <LeaderboardTable
      leaderboardTitle={leaderboardTitle}
      dataColumnHeader={dataColumnHeader}
      isExpanded={isExpanded}
      storeName={storeName}
      leaderboardData={leaderboardData}
    />
  )
}

export default React.memo(SalesLeaderboard)
